import React from 'react'
import Box from '@mui/material/Box';
import { useState,useEffect } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useAuthFetch } from "../api/authFetch";
import Button from '@mui/material/Button';
import {Link} from 'react-router-dom';

export default function DataGridDemo() {

  const columns: GridColDef[] = [
    { field: 'url', headerName: 'URL', width: 400,
    renderCell: (params) => (
      <><a href={`https://${params.value}`} target='_blank' rel="noreferrer">{params.value}</a><Link to={`/actions/${params.value}`}>
        <Button>Edit Actions</Button>
      </Link></>
    )
    },
    { field: 'usageCount', headerName: 'Usage count', width: 90 },
  ];

    const authFetch = useAuthFetch();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = React.useState(false)

    useEffect(() => {

      const loadData = async() => {

          setLoading(true)


          const response = await authFetch(process.env.REACT_APP_REPORTS_URL +"?reportId=rep001");
          
          if (response.status) {
              const events = await response.json();
              if (events != null)
                setTableData(events.rep001);
              setLoading(false)
            }
      };


    loadData();
    }, [authFetch])

  return (
    <Box sx={{ height: `auto`, width: '100%' }}>
      <DataGrid
        rows={tableData}
        columns={columns}
        pageSize={13}
        rowsPerPageOptions={[13]}
        disableSelectionOnClick
        autoHeight={true}
        experimentalFeatures={{ newEditingApi: true }}
        rowCount={tableData.length}
        loading={loading}
      />

    </Box>
  );
}